import React from 'react';
import { Rectangle } from 'recharts';
export const ReferenceAreaShape = ({ activeColumnGroup, referenceAreaFill }) => (React.createElement(Rectangle, { x: activeColumnGroup.x || 0, height: activeColumnGroup.height || 0, y: activeColumnGroup.y || 0, width: activeColumnGroup.width || 0, fill: referenceAreaFill }));
